import { AfterViewInit, Component, ElementRef, Input, OnChanges, OnInit, Renderer2 } from '@angular/core'

declare var Prism: any

@Component({
  selector: 'app-codeblock',
  templateUrl: './codeblock.component.html',
  styleUrls: ['./codeblock.component.scss']
})
export class CodeblockComponent implements AfterViewInit, OnChanges {

  @Input() code: string
  @Input() language: string
  private preNode: Node
  private codeNode: Node
  private nativeElement: Node

  ngAfterViewInit() {
    this.highlight()
  }

  ngOnChanges() {
    this.highlight()
  }

  constructor(private _renderer: Renderer2, private _el: ElementRef) {
    this.nativeElement = _el.nativeElement
  }

  highlight() {
    if (this.preNode && this.codeNode) {
      this._renderer.removeChild(this.preNode, this.codeNode)
      this._renderer.removeChild(this.nativeElement, this.preNode)
      this._renderer.destroyNode(this.preNode)
      this._renderer.destroyNode(this.codeNode)
    }

    this.preNode = this._renderer.createElement('pre')
    this.codeNode = this._renderer.createElement('code')

    this._renderer.addClass(this.codeNode, 'language-' + this.language)
    this._renderer.appendChild(this.nativeElement, this.preNode)
    this._renderer.appendChild(this.preNode, this.codeNode)

    this.codeNode.textContent = this.code

    Prism.highlightElement(this.codeNode)
  }

}



// WEBPACK FOOTER //
// C:/Users/Thomas/Projekte/palettes/src/app/shared/components/codeblock/codeblock.component.ts